import { createContext, useContext } from 'react';

import type { LegalDocKey } from '@escala/domain/legal';

export interface LegalApi {
  /** Abre os documentos (Privacidade, Termos ou Cookies), com o nome da igreja quando houver. */
  openLegal: (doc?: LegalDocKey, options?: { orgName?: string }) => void;
  /** Abre as "Preferências de cookies". */
  openCookies: () => void;
}

export const LegalContext = createContext<LegalApi | null>(null);

export function useLegal(): LegalApi {
  const value = useContext(LegalContext);

  if (!value) throw new Error('useLegal precisa estar dentro de <PrivacyProvider>.');

  return value;
}
